export const listMailCanSeeQte = ['moncefjouets@gmail.com', 'hassenkarnit@gmail.com', 'souna-anbu@hotmail.fr'];
